import { useRouteQuery } from '@/common/route/useRouteQuery';
import { pageSize } from '@/common/utils/helpers';
import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { roleService } from '@/services/role';

export default function () {
    const crudAction = useCrudActions();

    const { query, updateQueryToRoute } = useRouteQuery({
        definition: {
            offset: { type: 'number', default: 0 },
            limit: { type: 'number', default: pageSize }
        },
        onChange: () => fetchList()
    });

    const { list, total, fetchList } = useBaseListView({
        request: roleService.app.list,
        paramsBuilder: () => ({ ...query }),
        hooks: {
            onPageChange: offset => (query.offset = offset),
            onSuccess: updateQueryToRoute
        }
    });

    const actions = {
        removeAppRole: crudAction.confirmAndRemove({
            request: roleService.app.remove,
            onSuccess: () => fetchList()
        })
    };

    return { list, total, query, fetchList, actions };
}
